<h2 mat-dialog-title>Informações do Teste</h2>
<mat-dialog-content>
    <!--template dos steppers-->
    <ng-template #testStep>
        <form [formGroup]="formTest" style="padding-top: 10px;">

            <div class="row">
                <mat-form-field appearance="fill">
                    <mat-label>Nome do teste</mat-label>
                    <input type="text" placeholder="Nome do teste" matInput formControlName="name" />
                </mat-form-field>
            </div>

            <div class="row">
                <mat-form-field appearance="fill">
                    <mat-label>Descrição do teste</mat-label>
                    <textarea matInput placeholder="Descrição do teste" rows="10" style="max-height: 150px;"
                        formControlName="description"></textarea>
                    <mat-hint>Opcional</mat-hint>
                </mat-form-field>
            </div>
        </form>
    </ng-template>
    <ng-template #questionStep>

        <ng-container *ngIf="questions.length > 0">
            <span class="mat-title">Perguntas</span>

            <mat-list style="margin-bottom: 20px;">
                <mat-list-item *ngFor="let question of questions; let i = index" style="padding-bottom: 10px;">
                    <h3 matLine>{{ question.descriptionQuestion }}</h3>
                    <p matLine>
                        {{ question.questionType }}
                    </p>
                    <span matLine *ngIf="question.questionType !== 'dissertative'">
                        {{ question.options.length }} opções
                    </span>
                    <button mat-icon-button color="primary" (click)="openQuestionDialog(question)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button (click)="removeQuestion(i)" color="warn">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-list-item>
            </mat-list>
            <mat-divider></mat-divider>
        </ng-container>

        <div class="controls">
            <button mat-raised-button color="primary" class="custom-button" type="button"
                (click)="openQuestionDialog()">
                Adicionar pergunta
            </button>
        </div>

    </ng-template>
    <!--template dos steppers-->

    <mat-vertical-stepper #verticalStepper *ngIf="(isSmallScreen$ | async); else largeStepper" [linear]="true">
        <mat-step label="Sobre o Teste" [stepControl]="formTest">
            <ng-container *ngTemplateOutlet="testStep"></ng-container>
            <div class="actions">
                <button mat-stroked-button color="primary" matStepperNext>Próximo</button>
            </div>
        </mat-step>
        <mat-step label="Questionário" [stepControl]="formTest">
            <ng-container *ngTemplateOutlet="questionStep"></ng-container>
        </mat-step>
    </mat-vertical-stepper>

    <ng-template #largeStepper>
        <mat-horizontal-stepper [linear]="true">
            <mat-step label="Sobre o Teste" [stepControl]="formTest">
                <ng-container *ngTemplateOutlet="testStep"></ng-container>
                <div class="actions">
                    <button mat-stroked-button color="primary" matStepperNext>Próximo</button>
                </div>
            </mat-step>
            <mat-step label="Questionário" [stepControl]="formTest">
                <ng-container *ngTemplateOutlet="questionStep"></ng-container>
            </mat-step>
        </mat-horizontal-stepper>
    </ng-template>

</mat-dialog-content>
<mat-progress-bar *ngIf="submiting"></mat-progress-bar>
<!--Botão de salvar pergunta adicionado ao lado do salvar teste-->
<mat-dialog-actions *ngIf="!submiting">
    <button mat-button color="warn" mat-dialog-close>Fechar</button>
    <button mat-raised-button color="primary" (click)="submit()"
        [disabled]="formTest.invalid || showFormQuestion == true || questions.length == 0">Salvar</button>
</mat-dialog-actions>